import React from 'react';

interface ImageGalleryButtonProps {
  imageCount: number | undefined;
  onClick: () => void;
}

const ImageGalleryButton = ({
  imageCount,
  onClick,
}: ImageGalleryButtonProps) =>
  imageCount && imageCount > 0 ? (
    <button
      className="ac-result__gallery-btn ch-rounded--sm ch-color--white ch-fs--1 ch-fw--500 ch-ph--1 ch-absolute js-off--hide"
      onClick={onClick}
      type="button"
    >
      <span className="ac-result__image-count ch-display--inline-block ch-relative ch-mr--1 ch-pl--4 ch-pr--1">
        {imageCount}
      </span>
      Quick look
    </button>
  ) : null;

export default React.memo(ImageGalleryButton);
